<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
/* ============
 * Entry Point
 * ============
 *
 * The entry point of the application
 */

import store from "./store";
import { router } from "./../bootstrap";
import accountService from "./services/account";

export default {
  /**
   * The Vuex store
   */
  store,

  /**
   * The router
   */
  router,

  /**
   * Fires when the app has been mounted
   */
  async mounted() {
    // If the user is authenticated,
    // fetch the data from the API
    if (this.$store.state.auth.authenticated) {
      await accountService.find(this);
    }

    // const crispExcept = [
    //   /get-available-rentals/,
    //   /rental\/[^\/]+/,
    //   /create-booking\/[^\/]+/,
    //   /\/p\/[^\/]+/, // payment pages
    //   /\/booking\/(.*)\/contract/,
    //   /\/invoice\/[^\/]+/, // payment pages
    // ];
    // const containsMatch = crispExcept.some(regex => regex.test(window.location.href));
    // if(containsMatch) {
    //   $crisp.push(["do", "chat:hide"])
    // }
  },
};
</script>
<style>
.crisp-client > div {
  box-shadow: none !important;
  border: none !important;
}
.crisp-client > div:hover {
  box-shadow: none !important;
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?6ae8055a